import { Component, ElementRef, HostListener, Input, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { LoginService } from '@core/services/login.service';
import { matchValidator } from '@layout/components/classes/customValidators';
import { Login } from '@layout/components/classes/login';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
interface Langu {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit, AfterViewInit {

  @ViewChild('resetpassword', { static: false }) resetpassword!: ElementRef;
  @ViewChild('loginAs', { static: false }) loginAs!: ElementRef;
  @ViewChild('dropdownBtnRef', { static: false }) dropdownBtnRef!: ElementRef;
  @ViewChild('dropdownMenuRef', { static: false }) dropdownMenuRef!: ElementRef;

  @Input() theme = 'regular';

  registerForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-Z0-9_-]{2,16}$/),
    ]),
    school_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      matchValidator('retypePassword', true),
    ]),
    retypePassword: new FormControl('', [
      Validators.required,
      matchValidator('password'),
    ]),
  });
  resetPasswordForm = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      matchValidator('retypePassword', true),
    ]),
    retypePassword: new FormControl('', [
      Validators.required,
      matchValidator('password'),
    ]),
  });
  forgetForm = new FormGroup({
    username_or_email: new FormControl('', [Validators.required]),
  });
  activeForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });
  @ViewChild('contactForm')
  contactForm!: NgForm;
  ngform: any;
  submitted = false;
  selectedValue = '';
  toggle_menu: boolean = true;
  bar: boolean = true;
  disable: boolean = true;
  usermodel = new Login('', '');
  validateAllFormFields: any;
  lang:any;
  langs: Langu[] = [
    {value: 'en', viewValue: 'English'},
    {value: 'es', viewValue: 'Español'},
    {value: 'pt', viewValue: 'Português'},
    {value: 'zh', viewValue: '简体中文'},
    {value: 'zh-Hant', viewValue: '繁体中文'},
    {value: 'ar', viewValue: 'العربيه'},
  ];

  loading = false;

  routes = {
    dashboard: '/index/school/dashboard',
    TeacherDashboard: '/index/teacher/dashboard',
    studenthomepage: '/index/student/home',
    payment: '/index/checkout',
    index_journeys: '/index/journeys',
    index_worldCup: '/index/world-cup-prediction',
    index_parent: '/index/homeschooling',
    index_individual: '/index/roadmap/1',
    paymentdetails: '/index/school/payment',
    activitydetails: '/index/activity',
    ProfilePlans: '/index/profile/subscription/3',
    learn2codePrograms: '/code2earn/apply',
    individual_journey: '/index/roadmap/'
  };

  user: any = null;
  dashboardRoute = '';

  loginResponse: any = null;
  isCommunityDropdownOpen = false;

  @HostListener('document:click', ['$event'])
  clickout(event: any) {
    if (
      this.dropdownBtnRef &&
      this.dropdownBtnRef.nativeElement.contains(event.target)
    ) {
    } else {
      this.isCommunityDropdownOpen = false;
    }
    if (
      this.dropdownMenuRef &&
      this.dropdownMenuRef.nativeElement.contains(event.target)
    ) {
      this.isCommunityDropdownOpen = false;
    }
  }

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private global: LoginService,
    private toastr: ToastrService,
    private router: Router,
    private activatedRoute : ActivatedRoute
  ) {
    const innerwidth = document.body.scrollWidth;
    console.log(innerwidth);

    if (innerwidth < 992) {
      this.bar = true;
      this.toggle_menu = false;
    }
  }
  ngOnInit(): void{
    this.lang = localStorage.getItem('language') || 'en';
    this.selectedValue = localStorage.getItem('language') || 'en';
    this.checkUserData();
  }

  ngAfterViewInit(): void {
    const params = this.activatedRoute.snapshot.queryParams
    if (this.router.url.includes('resetpassword')) {
      if (params?.email && params?.token) this.openResetPassword(this.resetpassword)
      else this.router.navigate(['/']);
    }
  }

  togg() {
    console.log(this.toggle_menu);
    return (this.toggle_menu = !this.toggle_menu);
  }

  @HostListener('window:resize', [])
  onWindowScroll() {
    const offset = document.body.scrollWidth;

    if (offset < 992) {
      this.bar = true;
      this.toggle_menu = false;

      console.log(this.bar);
      console.log(this.toggle_menu);
    } else {
      this.bar = true;
      this.toggle_menu = true;
      console.log(this.bar);
      console.log(this.toggle_menu);
    }
  }
  openLoginAs(closeToggle?: any, closePopup?: any) {
    const loginAsModal = this.modalService.open(this.loginAs, { ariaLabelledBy: 'modal-basic-title' }).result.then(
      (result) => {},
      (reason) => {}
    );
  }
  onSelectRole(role: string): void {
    if (!this.user) this.checkUserData();
    if (this.user) {
      this.user.role = role;
      localStorage.setItem('AuthorizationData', JSON.stringify(this.user));
      this.checkUserData();
      this.redirect(this.loginResponse?.Object, 0)
    }
  }
  openLogin(login: any, closeToggle: any, closePopup: any) {
    this.modalService
      .open(login, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
  openJoin(join: any, closeToggle: any, closePopup: any) {
    this.modalService
      .open(join, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
  openForgetPassword(Forget: any, closeToggle: any, closePopup: any) {
    this.modalService
      .open(Forget, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
  openActiveCode(Code: any, closeToggle: any, closePopup: any) {
    this.modalService
      .open(Code, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
  openResetPassword(resetpassword: any, closeToggle?: any, closePopup?: any) {
    this.modalService
      .open(resetpassword, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {},
        (reason) => {}
      );
  }
  closeToggle() {
    const innerwidth = document.body.scrollWidth;
    if (innerwidth < 992) {
      this.toggle_menu = false;
      this.bar = true;
    }
  }
  closePopup() {
    this.modalService.dismissAll();
  }
  Login(data?: any) {
    this.loading = true;
    const body = data || {username: this.usermodel.username, password: this.usermodel.password};
    this.global.getLogin(body).subscribe(
        (res) => {
          this.loading = false;
          this.loginResponse = res;
          console.log(res);
          this.logUserIn(res);
          this.checkUserData();
          this.closePopup();
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
  }

  logout() {
    this.loading = true;
    this.logUserOut();
    this.checkUserData();
    location.href = '';
    this.loading = false;
  }

  logUserIn(res: any): void {
    this.setLocalStorage(res?.Object);
    this.global.getScoresLogin(res?.Object?.token?.token).subscribe((response) => {
      var scores = response.Object;
      var score = {
        'xp': scores.xp,
        'coins': scores.coins
      };
      localStorage.setItem('score', JSON.stringify(score));
      if (this.user?.roles?.length > 1 && this.user.hasAdminLoginAs && this.user.features?.includes('teacher_admin')) {
        this.openLoginAs();
      } else {
        this.redirect(res?.Object, 0);
      }
    }, err => {
      if (this.user?.roles?.length > 1 && this.user.hasAdminLoginAs && this.user.features?.includes('teacher_admin')) {
        this.openLoginAs();
      } else {
        this.redirect(res?.Object, 0);
      }
    });
  }
  logRegisterUserIn(res: any): void {
    this.setRegisterLocalStorage(res?.Object);
    this.redirect(res?.Object, 0);
  }
  logUserOut = function () {
    localStorage.removeItem('AuthorizationData');
    localStorage.removeItem('satellizer_token');
    localStorage.removeItem('score');
    localStorage.removeItem('student_id');
    localStorage.removeItem('mail');
    localStorage.removeItem('students');
    localStorage.removeItem('schoolinvited');
    localStorage.removeItem('schoolsubscription');
    localStorage.removeItem('subscription_enddate');
  };
  get username() {
    return this.registerForm.get('username');
  }
  get schoolname() {
    return this.registerForm.get('schoolname');
  }
  get email() {
    return this.registerForm.get('email');
  }
  get password() {
    return this.registerForm.get('password');
  }
  get retypePassword() {
    return this.registerForm.get('retypePassword');
  }
  get userEmail() {
    return this.forgetForm.get('username_or_email');
  }
  get Email() {
    return this.activeForm.get('email');
  }
  get resetPassword() {
    return this.resetPasswordForm.get('password');
  }
  get resetRetypePassword() {
    return this.resetPasswordForm.get('retypePassword');
  }
  mustMatch(password: any, retypePassword: any) {
    return (formGroup: FormGroup) => {
      const passwordControl = formGroup.controls[password];
      const retypePasswordControl = formGroup.controls[retypePassword];
      if (
        retypePasswordControl.errors &&
        !retypePasswordControl.errors['mustMatch']
      ) {
        return;
      }
      if (passwordControl.value == retypePasswordControl.value) {
        retypePasswordControl.setErrors({ mustMatch: true });
      } else {
        retypePasswordControl.setErrors(null);
      }
    };
  }
  get userInfo() {
    return this.registerForm.controls;
  }
  get passwordMatchError() {
    return (
      this.registerForm.getError('mismatch') &&
      this.registerForm.get('retypePassword')?.touched
    );
  }

  register() {
    this.submitted = true;
    this.loading = true;
    const body = this.registerForm.value;
    const loginBody = { username: body.username, password: body.password };
    this.global.getRegister(this.registerForm.value).subscribe(
      (res) => {
        this.loading = false;
        console.log(res);
        this.Login(loginBody);
        this.closePopup();
      },
      (err) => {
        this.loading = false;
        console.log(err.error.errorMessage);
      }
    );
  }

  resetPass() {
    const retypePassword = this.resetPasswordForm.get('retypePassword')?.value;
    const params = this.activatedRoute.snapshot.queryParams

    this.loading = true;

    const body = {
      token: params?.token,
      email: params?.email,
      password: retypePassword,
    };

    this.global.getResetPassword(body, this.selectedValue).subscribe(
      (res) => {
        this.loading = false;
        console.log(res);
        this.closePopup();
      },
      (err) => {
        this.loading = false;
        console.log(err.error.errorMessage);
      }
    );
  }
  forgetPassword() {
    this.loading = true;
    this.global.getForgetPassword(this.forgetForm.value, this.selectedValue).subscribe(
      (res) => {
        this.loading = false;
        console.log(res);
        this.toastr.success(res.Object);
      },
      (err) => {
        this.loading = false;
        console.log(err.error.errorMessage);
      }
    );
  }
  resendCode() {
    this.loading = true;
    this.global.getResendCode(this.activeForm.value).subscribe(
      (res) => {
        this.loading = false;
        this.toastr.success(res.Object);
      },
      (err) => {
        this.loading = false;
        console.log(err.error.errorMessage);
      }
    );
  }
  changeLang(){
    localStorage.setItem('language',this.selectedValue);
    window.location.reload();
  }

  redirect(result: any, isCompetitionStudent: number) {
    if(localStorage.getItem('redirectProfilePlans')) //OR (window.location.href.includes('leaderboard'))
    {
        localStorage.removeItem('redirectProfilePlans');
        localStorage.setItem('openProfilePlans', 'true');
        window.location.replace(this.routes.ProfilePlans);


    }
    else if(this.user?.role == 'school_admin')
    {
        //if(RobogardenServices.getPlan()) //FIXME not implemented
        //window.location.replace(this.routes.dashboard);
        //else
        // window.location.replace(this.routes.dashboard);

        if (localStorage.getItem('school_redirect_plans')) //from school plans
        {
            localStorage.removeItem('school_redirect_plans');
            window.location.replace(this.routes.paymentdetails);
        } else {
            window.location.replace(this.routes.dashboard);
        }
    } else if (this.user?.role == 'teacher')
        window.location.replace(this.routes.TeacherDashboard);
    else if (this.user?.role == 'student')
        window.location.replace(this.routes.studenthomepage);
    else if (this.user?.isCompetitionStudent && isCompetitionStudent)
        window.location.replace(this.routes.learn2codePrograms);
    else if (localStorage.getItem('worldUser')) //OR (window.location.href.includes('leaderboard'))
    {
        localStorage.removeItem('worldUser');
        window.location.replace(this.routes.index_worldCup);
    } else if (localStorage.getItem('homescholer_registered')) //from school plans
    {
        localStorage.removeItem('homescholer_registered');
        window.location.replace(this.routes.index_parent);
    } else if (localStorage.getItem('learner_registered')) //from school plans
    {
        localStorage.removeItem('learner_registered');
        window.location.replace(this.routes.index_individual);
    }else if (('redirectToJourney' in result) && ('redirectToJourneyId' in result) &&
     result.redirectToJourney){

        window.location.replace(this.routes.individual_journey+result.redirectToJourneyId);
    }
    else {
        //if(RobogardenServices.getPlan()) //FIXME not implemented
        //window.location.replace(this.routes.payment + '/' + result.account_type);
        //else
        window.location.replace(this.routes.index_journeys);
    }
  }

  setLocalStorage(result: any) {
    if (result?.user) {
      const authorizationData = {
        'username': result.user?.username,
        'email': result.user?.email,
        'fname': result.user?.first_name,
        'lname': result.user?.last_name,
        'id': result.user?.id,
        'image_link': result.user?.profile_image_url,
        'logged_in': true,
        'social_id': result.user?.social_id,
        'social_track': result.user?.social_track,
        'role': result.user?.role,
        'roles': result.user?.roles,
        'hasAdminLoginAs': result.user?.hasAdminLoginAs,
        'trialEnd': result.trialEnd,
        'country': result.user?.account?.country,
        'robopal': result.RoboPalAuth ? result.RoboPalAuth.permission : '',
        'robopal_end': result.RoboPalAuth ? result.RoboPalAuth.end_date : '',
        'robopal_cancelled': result.RoboPalAuth ? result.RoboPalAuth.cancelled : '',
        'status': result.status ? result.status : result.user?.account?.status ? result.user?.account.status : result.account?.status,
        'account_type': result.account_type,
        'invited': result.invited,
        'is_admin': result.user?.is_admin,
        'isCompetitionStudent': result.user?.isCompetitionStudent,
        'CompetitionStudentGrade': result.user?.CompetitionStudentGrade,
        'CompetitionCountry': result.user?.CompetitionCountry,
        'isOrangeServiceUser': result.user?.isOrangeServiceUser,
        'currentJourneyId': result.user?.user_position?.JourneyId,
        'is_ceibal_user': result.user?.is_ceibal_user,
        "inCeibalOlympiad":result.user?.inCeibalOlympiad,
        is_eupheusschoolos_user:result.user?.is_eupheusschoolos_user,
        'features': result.features
      };
      if(result.user?.is_ceibal_user){
        // window.location.href='/set-locale/es'
        localStorage.setItem('language','es')
      }
      localStorage.setItem('satellizer_token', result.token.token);
      localStorage.setItem('AuthorizationData', JSON.stringify(authorizationData));
      localStorage.setItem('stripe_user', result.use_stripe);
      this.checkUserData();
    }
  }
  setRegisterLocalStorage(result: any) {
    const authorizationData = {
      'username': result.username,
      'email': result.email,
      'fname': result.first_name,
      'lname': result.last_name,
      'id': result.id,
      'image_link': result.profile_image_url,
      'logged_in': true,
      'social_id': result.social_id,
      'social_track': result.social_track,
      'role': result.role?.length ? result.role[0].name : '',
      'trialEnd': result.trialEnd,
      'country': result.account?.country,
      'robopal': result.RoboPalAuth ? result.RoboPalAuth.permission : '',
      'robopal_end': result.RoboPalAuth ? result.RoboPalAuth.end_date : '',
      'robopal_cancelled': result.RoboPalAuth ? result.RoboPalAuth.cancelled : '',
      'status': result.status ? result.status : result.account?.status ? result.account.status : result.account?.status,
      'account_type': result.account_type,
      'invited': result.invited,
      'is_admin': result.is_admin,
      'isCompetitionStudent': result.isCompetitionStudent,
      'CompetitionStudentGrade': result.CompetitionStudentGrade,
      'CompetitionCountry': result.CompetitionCountry,
      'isOrangeServiceUser': result.isOrangeServiceUser,
      'currentJourneyId': result.user_position?.JourneyId,
      'is_ceibal_user': result.is_ceibal_user,
      "inCeibalOlympiad":result.user?.inCeibalOlympiad,
      is_eupheusschoolos_user:result.user?.is_eupheusschoolos_user,
    };
    if(result.is_ceibal_user){
      // window.location.href='/set-locale/es'
      localStorage.setItem('language','es')
    }
    localStorage.setItem('satellizer_token', result.token?.token);
    localStorage.setItem('AuthorizationData', JSON.stringify(authorizationData));
    localStorage.setItem('stripe_user', result.use_stripe);
    localStorage.setItem('score', JSON.stringify(result.score));
    this.checkUserData();
  }

  checkUserData(): void {
    const user = localStorage.getItem('AuthorizationData');
    if (user) this.user = JSON.parse(user);
    else this.user = null;
    this.getDashboardRoute();
  }

  getDashboardRoute(): void {
    if (this.user?.is_admin) {
      this.dashboardRoute = '/index/journeys';
    } else if (this.user?.role === 'school_admin') {
      this.dashboardRoute = '/index/school/dashboard';
    } else if (this.user?.role === 'teacher') {
      this.dashboardRoute = '/index/teacher/dashboard';
    } else if (this.user?.role === 'student') {
      this.dashboardRoute = '/index/student/home';
    } else {
      this.dashboardRoute = '/index/journeys';
    }
  }

}

